import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {requestOK} from 'redux-thunk-kit';
import {getSignedUrlS3} from '~/redux/apps/thunk';

export function useS3Service() {
  const dispatch: AppDispatch = useDispatch();

  const getSignedUrl = useCallback(
    async (url: string) => {
      const resAction = await dispatch(getSignedUrlS3({file: url}));
      if (requestOK(resAction, getSignedUrlS3)) {
        // @ts-ignore
        return resAction?.payload?.url || '';
      }
    },
    [dispatch],
  );

  return {getSignedUrl};
}
